import axios from 'axios'
import { Auth } from './Auth'
import { useAuthStore } from '@stores/auth'
import createAuthRefreshInterceptor from 'axios-auth-refresh'

const authUrls = [
  '/api/token/refresh/',
  '/password/reset/'
]

const ax = axios.create({
  baseURL: `${Auth.API_URL}/api`
})

const refreshAuthLogic = async(failedRequest) => {
  const authStore = useAuthStore()
  try {
    await authStore.ensureAccessToken()
  } catch (error) {
    if ( error.error  === 'login_required' ) {
      authStore.logOut()
    } else {
      throw error
    }
  }
  failedRequest.response.config.headers['Authorization'] =
    'Bearer ' + Auth.accessToken
}

if (process.env.NODE_ENV !== 'test') {
  createAuthRefreshInterceptor(ax, refreshAuthLogic)
}

ax.interceptors.request.use((config) => {
  if (authUrls.includes(config.url)) {
    return config
  }
  const accessToken = Auth.accessToken
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`
  }

  // Only set the Content-Type header to 'application/json' if the request data is NOT FormData
  if (!(config.data instanceof FormData)) {
    config.headers['Content-Type'] = 'application/json'
  }
  // Content-Type is removed when there is no data in the payload
  // https://github.com/axios/axios/blob/main/lib/adapters/xhr.js#L161
  // and anyways it's telling the server the type of the payload sent
  // so let's set what data we expect back instead. We always only talk
  // to our API which sends back JSON
  config.headers['Accept'] = 'application/json'
  return config
})

ax.interceptors.response.use(
  (response) => response,
  async(error) => {
    const { config: originalRequest, response } = error
    const authStore = useAuthStore()
    if (!originalRequest?._retry && response?.status === 401 && !originalRequest?.ignoreGlobalCatch) {
      authStore.logOut()
    }

    return Promise.reject(error)
  }
)

export default ax
